const organizationData = state => state;
const businessProcesses = state => state.businessProcesses;

const dispositionCodeCategorySetPerBp = state => businessProcessId => {
  const businessProcess = state.businessProcesses.find(bp => bp.id === businessProcessId);

  const dispositionCodeCategorySet = businessProcess ? businessProcess.dispositionCodeCategorySet : null;
  const dispositionCodeCategorySetId = dispositionCodeCategorySet ? dispositionCodeCategorySet.id : null;

  return (state.dispositionCodeCategorySets || []).find(
    dispositionCode => dispositionCode.id === dispositionCodeCategorySetId
  );
};

const getOrganizationBPbyId = state => businessProcessId => {
  return state.businessProcesses.find(bp => bp.id === businessProcessId);
};

const getInteractionDetailsDisplayTemplateForBP = state => businessProcessId => {
  const businessProcess = state.businessProcesses.find(bp => bp.id === businessProcessId);
  const id =
    businessProcess && businessProcess.interactionDetailsDisplayTemplate
      ? businessProcess.interactionDetailsDisplayTemplate.id
      : businessProcess && businessProcess.id
      ? businessProcess.id
      : null;

  return (state.interactionDetailsDisplayTemplates || []).find(template => template.id === id);
};

const postponeOptions = state => businessProcessId => {
  const businessProcess = state.businessProcesses.find(bp => bp.id === businessProcessId);
  return (businessProcess || {}).postponeOptions;
};
const breakCategories = state => state.breakCategories;
const breakTypes = state => state.breakTypes;

const orgId = state => state.orgId;
const orgName = state => state.orgName;
const orgKafkaTopicName = state => state.orgKafkaTopicName;
const orgShortName = state => state.orgShortName;
const orgReportingServerUrl = state => state.orgReportingServerUrl;

const configurationVersion = state => state.configurationVersion;

const dispositionCodeCategorySets = state => state.dispositionCodeCategorySets;

const enableIncomingCallRemoteAcceptOnPrimaryDevice = state => state.enableIncomingCallRemoteAcceptOnPrimaryDevice;

const interactionDetailsDisplayTemplates = state => state.interactionDetailsDisplayTemplates;
const interactionVariables = state => state.interactionVariables;
const skills = state => state.skills;

const customerAIAssistanceBotURL = state => state.customerAIAssistanceBotURL;
const loadAllowances = state => state.loadAllowances;

export default {
  organizationData,
  businessProcesses,
  postponeOptions,
  breakCategories,
  breakTypes,

  orgId,
  orgName,
  orgShortName,
  orgKafkaTopicName,
  orgReportingServerUrl,

  configurationVersion,
  dispositionCodeCategorySets,
  dispositionCodeCategorySetPerBp,
  enableIncomingCallRemoteAcceptOnPrimaryDevice,
  interactionDetailsDisplayTemplates,
  interactionVariables,
  getInteractionDetailsDisplayTemplateForBP,
  getOrganizationBPbyId,
  skills,
  customerAIAssistanceBotURL,
  loadAllowances
};
